"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _authenticate = require("../../mixins/authenticate");

var _authenticate2 = _interopRequireDefault(_authenticate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = require("moment");
exports.default = {
  props: ["project", "companies", "departments", "offices", "secret"],

  data: function data() {
    return {
      firstname: null,
      lastname: null,
      email: null,
      personalNumber: null,
      dateOfBirth: "",
      phoneWithCountry: null,
      userGender: "",
      company: "",
      office: "",
      department: "",
      validationErrors: {
        firstname: [],
        lastname: [],
        email: [],
        personalNumber: [],
        dateOfBirth: [],
        phone: [],
        gender: [],
        company: [],
        office: [],
        department: []
      },
      currentOffices: [],
      currentDepartments: [],
      isPhoneValid: false,
      dropdownOptions: {},
      isSigningUp: true
    };
  },


  /**
   * Mixins
   */
  mixins: [_authenticate2.default],

  mounted: function mounted() {
    var _this = this;

    this.$store.subscribe(function (mutation) {
      var validationErrorsExists = false;

      for (var validationGroup in _this.validationErrors) {
        if (_this.validationErrors[validationGroup].length) {
          validationErrorsExists = true;
          break;
        }
      }

      if (validationErrorsExists) {
        _this.clearValidationErrors();
        _this.isFormValid();
      }
    });
    this.dropdownOptions = {
      width: "100%",
      showFlags: true,
      showDialCodeInList: true
    };
  },


  methods: {
    setCompany: function setCompany() {
      this.setOffice({});
    },
    setOffice: function setOffice() {
      this.setDepartment({});
    },
    setDepartment: function setDepartment(department) {
      this.department = department;
    },
    clearValidationErrors: function clearValidationErrors() {
      var _this2 = this;

      // Clear errors object.
      Object.keys(this.validationErrors).forEach(function (key) {
        return _this2.validationErrors[key] = [];
      });
    },
    authenticate: function authenticate() {
      if (this.isSigning) {
        return;
      }

      this.clearValidationErrors();
      if (!this.isFormValid()) {
        return;
      }

      this.message = null;
      this.isError = false;
      this.startSignup();
    },
    isFormValid: function isFormValid() {
      var _this3 = this;

      if (!this.firstname) {
        this.validationErrors.firstname.push(this.$t("sign_up.validation.firstname.empty"));
      }

      if (!this.lastname) {
        this.validationErrors.lastname.push(this.$t("sign_up.validation.lastname.empty"));
      }

      if (!this.email) {
        this.validationErrors.email.push(this.$t("sign_up.validation.email.empty"));
      }

      if (this.email && !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(this.email.toLowerCase())) {
        this.validationErrors.email.push(this.$t("sign_up.validation.email.incorrect_format"));
      }

      if (!this.personalNumber || this.personalNumber.length !== 12) {
        this.validationErrors.personalNumber.push(this.$t("sign_up.validation.personal_number.incorrect_length"));
      }

      if (this.personalNumber && this.personalNumber.length >= 8 && !moment(this.personalNumber.substr(0, 8)).isValid()) {
        this.validationErrors.dateOfBirth.push(this.$t("sign_up.validation.date_of_birth.invalid_date"));
      }

      if (!this.phoneWithCountry) {
        this.validationErrors.phone.push(this.$t("sign_up.validation.phone.empty"));
      }

      if (!this.isPhoneValid) {
        this.validationErrors.phone.push(this.$t("sign_up.validation.phone.invalid"));
      }

      if (!this.userGender) {
        this.validationErrors.gender.push(this.$t("sign_up.validation.gender.empty"));
      }

      if (this.companies.length && !this.company) {
        this.validationErrors.company.push(this.$t("sign_up.validation.company.empty"));
      }

      if (this.currentOffices.length && !this.office) {
        this.validationErrors.office.push(this.$t("sign_up.validation.office.empty"));
      }

      if (this.currentDepartments.length && !this.department) {
        this.validationErrors.department.push(this.$t("sign_up.validation.department.empty"));
      }

      return Object.keys(this.validationErrors).reduce(function (accumulator, key) {
        return accumulator && !_this3.validationErrors[key].length;
      }, true);
    },
    validatePhone: function validatePhone(phone) {
      this.isPhoneValid = phone.isValid;
    },
    startSignup: function startSignup() {
      var _this4 = this;

      var toastr = this.$toastr;
      var vm = this;
      this.isError = false;
      this.clearValidationErrors();
      axios.post("/signup/" + this.secret, {
        personal_number: this.personalNumber,
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        date_of_birth: this.dateOfBirth,
        phone: this.phoneWithCountry,
        gender: this.userGender.id,
        company_id: this.company ? this.company.id : null,
        office_id: this.office ? this.office.id : null,
        department_id: this.department ? this.department.id : null,
        project_guid: this.secret,
        locale: this.$i18n.locale
      }).then(function (res) {
        if (res.data.personal_number_exists || res.data.email_exists) {
          toastr.options.positionClass = "toast-top-center";
          var message = res.data.personal_number_exists ? _this4.$t("sign_up.messages.personal_number_is_registered") : _this4.$t("sign_up.messages.email_is_registered");
          toastr.warning(message);

          setTimeout(function () {
            window.location.replace(window.location.protocol + "//" + window.location.hostname + "/login");
          }, 2000);
          vm.stop();

          return;
        }

        vm.sid = res.data.sid;
        _this4.isError = false;
        _this4.isSigningUp = false;
      }).catch(function (_ref) {
        var response = _ref.response;

        vm.message = _.get(response, "data.message", _this4.$t("common.messages.unknown_error"));

        _.each(response.data.data, function (errors, input) {
          Vue.set(_this4.validationErrors, input, errors);
        });

        vm.stop();
      });
    },
    stop: function stop() {
      clearInterval(this.interval);
      this.sid = null;
      this.isError = true;
    }
  },

  computed: {
    gender: function gender() {
      return [{ name: this.$t("user_profile.placeholders.gender_male"), id: "male" }, {
        name: this.$t("user_profile.placeholders.gender_female"),
        id: "female"
      }];
    },
    filteredOffices: function filteredOffices() {
      var _this5 = this;

      this.currentDepartments = [];
      var currentOffices = _(this.offices).filter(function (office) {
        return office.company_id === _this5.company.id;
      }).value();
      this.currentOffices = currentOffices;

      return _.isEmpty(currentOffices) ? null : currentOffices;
    },
    filteredDepartments: function filteredDepartments() {
      var _this6 = this;

      var currentDepartments = _(this.departments).filter(function (department) {
        return department.office_id === _this6.office.id;
      }).value();
      this.currentDepartments = currentDepartments;

      return _.isEmpty(currentDepartments) ? null : currentDepartments;
    }
  },

  watch: {
    personalNumber: function personalNumber() {
      if (this.personalNumber && this.personalNumber.length >= 8 && moment(this.personalNumber.substr(0, 8)).isValid()) {
        this.dateOfBirth = moment(this.personalNumber.substr(0, 8)).format("YYYY-MM-DD");
      } else if (this.dateOfBirth) {
        this.dateOfBirth = "";
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/SignUpFormBankId.vue
// module id = ubki
// module chunks = 0 1